<template>
    <div class="chat">
        <UploadFiles v-if="files" :files="files" :projectId="project.id" @cancel="uploaded" @done="uploaded">
        </UploadFiles>
        <div class="accept" @click="$store.dispatch('projects/assignToSelf', project.id)"
            v-if="project.worker == null && role == 'worker'">
            <button>Aceitar</button>
        </div>
        <br>
        <ul class="messages" ref="messages">
            <div class="loading">Não há mais mensagens</div>
            <ChatMessage v-for="message in messages" :key="message.id" :message="message">
            </ChatMessage>
        </ul>

        <form @submit.prevent.stop="sendMessage" class="form"
            :class="{ disabled: role == 'worker' && project.worker == null }">
            <div class="inputBar" v-if="role != 'admin' && !project.done">
                <textarea autofocus placeholder="Escreva aqui a sua mensagem" ref="textarea"
                    :style="{ height: chatInputHeight }" v-model="chatMessage" @keydown="handleKeyDown" />
                <label class="attachment" for="project">
                    <input class="input" id="project" name="project" type="file" ref="fileInput" multiple
                        @change="uploadFiles($event)">
                    <IconComponent icon="clip" class="icon" />
                </label>
                <button v-if="chatMessage" class="button" type="submit">
                    <IconComponent class="icon" icon="send" />
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import ChatMessage from '@/components/chat/Message.vue'
import UploadFiles from '@/components/chat/Upload.vue'
import IconComponent from '@/components/Icons.vue'

export default {
    name: 'ChatBody',
    props: {
        project: { required: true }
    },
    components: {
        ChatMessage,
        IconComponent,
        UploadFiles,
    },
    data() {
        return {
            chatMessage: '',
            progress: 0,
            fileName: '',
            uploadTask: null,
            files: null,
            chatInputHeight: '3.25rem'
        }
    },

    methods: {
        chatMessageValue(e) {
            for (let file of e.target.files) {
                this.chatMessage += file.name + " ";
            }
        },

        sendMessage() {
            if (this.chatMessage == null) return

            this.$store.dispatch('projects/sendMessage', {
                projectId: this.project.id,
                message: this.chatMessage,
            })
            this.chatMessage = ''
        },

        handleKeyDown(e) {
            if (e.key === "Enter") {
                if (e.shiftKey) {
                    return;
                }
                e.preventDefault();
                this.sendMessage();
            }
        },

        uploaded() {
            this.$refs.fileInput.value = ""
            this.files = null
        },

        uploadFiles(e) {
            this.files = e.target.files
        },

        uploadFilesIntoProjects() {
            const file = this.$refs.fileInput.files[0]

            if (file == null) return
            this.fileName = file.name;
        },

        uploadStateChanged(snapshot) {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            this.progress = progress.toFixed(0);
            switch (snapshot.state) {
                case "paused":
                    console.log("Upload is paused");
                    break;
                case "running":
                    console.log("Upload is running");
                    break;
            }
        },
    },

    computed: {
        messages() {
            return this.$store.getters["messages/sorted"]
        },
        lastMessage() {
            return this.$store.getters["messages/lastMessage"]
        },
        currentUser() {
            return this.$store.state.users.currentUser
        },
        newMessage() {
            return {
                // createdAt: serverTimestamp(),
                messageSent: this.chatMessage,
                userId: this.currentUser.uid,
                userName: this.currentUser.displayName,
                userPhotoURL: this.currentUser.photoURL,
            }
        },
        role() {
            return this.$store.state.users.role
        },
        users() {
            return this.$store.state.users.all
        },

        instanceId() {
            return this.$store.state.instanceId
        },
    },

    watch: {
        chatMessage() {
            this.chatInputHeight = '3.25rem'
            this.$nextTick().then(() => {
                this.chatInputHeight = `${Math.min(this.$refs.textarea.scrollHeight, 200)}px`
            })
        },
        messages() {
            this.$nextTick().then(() => {
                this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight
            })
        },
    },

    mounted() {
        this.$store.dispatch('messages/getAll', this.project.id)
        this.$store.dispatch('projects/links/getAll', this.project.id)
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

.chat {
    position: relative;
    flex-direction: column;
    display: flex;
    background: rgba(var(--white), 1);
    border-radius: 10px;
    overflow: hidden;

    .accept {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;

        button {
            cursor: pointer;
            margin: auto;
            height: 3.5rem;
            padding: 0 2.5rem;
            background-color: var(--highlight-color);
            color: var(--white);
            font-weight: bold;
            font-size: 1.2rem;
            border: none;
            text-transform: uppercase;
        }
    }

    .messages {
        flex-grow: 1;
        overflow: auto;
        min-height: 0;
        margin: 0;
        padding: 0 1em;
    }

    .loading {
        text-align: center;
    }

    form {
        flex-shrink: 0;
        height: fit-content;


        &.disabled {
            pointer-events: none;
            opacity: .25;
        }
    }

    .form {
        margin-top: auto;

        .inputBar {
            display: flex;
            border-top: 1px solid rgba(var(--black), .3);
            overflow: hidden;
            width: 100%;
            height: fit-content;
            padding: 1rem;
            background-color: var(--bg-color-2);
            align-items: center;

            textarea {
                padding: 1rem;
                border-radius: 10px;
                border: none;
                display: block;
                width: 100%;
                background-color: var(--bg-color-3);
                height: auto;
                max-height: 200px;
                resize: none;
                font-size: 1rem;
                min-height: 1rem;
                height: 3rem;
                line-height: 1.25;
                align-items: center;
                justify-content: center;
                color: var(--text-color);

                &::placeholder {
                    color: var(--text-color);
                    opacity: .4;
                }

                &:focus {
                    outline: none;
                }
            }

            .attachment {
                display: flex;
                transition: .2s ease-out;
                transition-property: width, padding;
                display: flex;
                width: 2.5rem;
                height: 100%;
                padding: .5rem;
                cursor: pointer;

                .input {
                    display: none;
                }
            }

            button {
                cursor: pointer;
                height: 100%;
                padding: .75em;
                -webkit-user-drag: none;
                border: none;
                border-left: 1px solid rgba(var(--black), 1);
                border-radius: 0 0 10px 0;
                background: rgba(var(--highlight-color), .8);
                color: var(--error-color);

                svg {
                    fill: var(--text-color);
                }
            }
        }
    }
}

.icon {
    width: 20px;
    height: 20px;
    fill: var(--text-color);
}
</style>
